module.exports = __webpack_public_path__ + "img/icon.35e19ead.png";